module.exports = __webpack_public_path__ + "static/img/1.7a0fd63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1.jpg
// module id = eKea
// module chunks = 1